declare namespace $ {

	export class $bog_fragile_demo_outer_widget1 extends $mol_view {
		city( ): string
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=widget1.view.tree.d.ts.map